import { ModalService, Tenant, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Component, Input } from '@angular/core';
import { UserDto } from 'src/app/models/user/create-user-dto';
import { DeleteUserWarningModalComponent } from '../delete-user-warning-modal/delete-user-warning-modal.component';

@Component({
    selector: 'oaibox-user-row',
    templateUrl: './user-row.component.html',
    styleUrl: './user-row.component.css',
    imports: [WebAppCommonModule],
})
export class UserRowComponent {
  @Input({required: true}) user!: UserDto;
  @Input() tenant?: Tenant;

  constructor(private modalService: ModalService) {
  }

  protected deleteUser(): void {
    this.modalService.pushModal({
      component: DeleteUserWarningModalComponent,
      inputs: new Map<string, any>([
        ['user', this.user],
        ['tenant', this.tenant],
      ]),
      closeButtonColor: 'white',
    });
  }
}
